import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortString',
    standalone: true
})
export class SortStringPipe implements PipeTransform {
  transform(listArray: any[] | null | undefined, field: string | undefined, order: 'asc' | 'desc' = 'asc'): any[] {
    if(!listArray) {return []}
    if(!field) {return listArray}

    const array = [...listArray];
    const sortOrder = order === 'asc' ? 1 : -1;

    return array.sort((a, b) => {
      if(!a[field] || !b[field]) {return 0}
      return a[field].toLowerCase() > b[field].toLowerCase() ? sortOrder : -1 * sortOrder;
    })
  }
}
